export default {
  default: {
    proposalsAccepted: {
      title: 'Average Proposals Accepted',
    },
  },
}
